import { useEffect, useState } from "react";
import { TreeItem, TreeView } from "@mui/lab";
import { Box, Typography } from "@mui/material";
import { alpha } from '@mui/material/styles';
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import GroupIcon from '@mui/icons-material/Groups';
import PersonIcon from '@mui/icons-material/Person';

const AddressTreeViewSearch = ({ data, selectedNode, setSelectedNode, inputText, groupsList, showPersons, hasOpened, manualExpand, setManualExpand }) => {
  const [expand, setExpand] = useState([]);

  useEffect(() => {
    if (!hasOpened) return;

    if (inputText.trim()) {
      const expanded = new Set();

      const findMatches = (nodes, parentPath = []) => {
        nodes.forEach(node => {
          const label = node.label?.toLowerCase() || "";
          const match = label.includes(inputText.toLowerCase());

          if (match) parentPath.forEach(id => expanded.add(id));

          if (node.children) {
            findMatches(node.children, [...parentPath, node.id]);
          }
        });
      };

      findMatches(data);
      setExpand(Array.from(expanded));
    } else if (manualExpand.length > 0) {
      setExpand(manualExpand);
    } else {
      setExpand(groupsList);
    }
  }, [inputText, hasOpened]);


  const renderTreeNodes = (nodes) => {
    return nodes?.filter((node) => {
      if (showPersons || node.type === "OWN") {
        return node;
      }
      else if (node.type === "GROUP") {
        return node;
      }
    })
      ?.map((node) => {
        const matchesSearch = !inputText || node.label.toLowerCase().includes(inputText.toLowerCase());
        const filteredChildren = renderTreeNodes(node.children || []);

        const hasMatchingChildren = filteredChildren.length > 0;

        if (matchesSearch || hasMatchingChildren) {
          return (
            <TreeItem
              key={node.id}
              nodeId={node.id}
              selected={selectedNode?.id === node.id}
              classes={{
                root: node.type === 'GROUP' ? 'group-node' : '',
              }}
              label={
                <Box
                  onClick={() => setSelectedNode(node)}
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 1,
                    py: 0.5,
                    ...(node.type !== "GROUP" && {
                      opacity: 0.74,
                    }),
                  }}
                >
                  {node.type === "GROUP" ? (
                    <GroupIcon fontSize="small" sx={{ opacity: 0.6 }} />
                  ) : (
                    <PersonIcon fontSize="small" sx={{ opacity: 0.6 }} />
                  )}
                  {node.label}
                </Box>
              }
            >
              {filteredChildren}
            </TreeItem>
          );
        }

        return null;
      })
      .filter(Boolean);
  };


  return (
    <Box sx={{ paddingLeft: { xs: '4px', sm: '8px' } }}>
      <TreeView
        defaultCollapseIcon={<ExpandMoreIcon />}
        defaultExpandIcon={<ChevronRightIcon />}
        expanded={expand}
        onNodeToggle={(e, ids) => {
          setExpand(ids);
          //setManualExpand(ids);
        }}
        sx={(theme) => ({
          '& .MuiTreeItem-group': {
            marginLeft: '4px',
          },
          '& .group-node > .MuiTreeItem-content': {
            backgroundColor: alpha(theme.palette.primary.main, 0.02),
            borderRadius: 1,
            paddingLeft: { xs: '4px', sm: '8px' },
          },
          '& .group-node > .MuiTreeItem-content:hover': {
            backgroundColor: '#ddd',
          },
          '& .group-node.Mui-selected > .MuiTreeItem-content': {
            backgroundColor: '#c8e6c9', // selected background
          },
          '& .group-node.Mui-selected > .MuiTreeItem-content:hover': {
            backgroundColor: '#b2dfdb',
          },
        })}
      >
        {renderTreeNodes(data) ?? (
          <Typography padding={3} paddingLeft={2}>No options</Typography>
        )}
      </TreeView>
    </Box>
  );
};

export default AddressTreeViewSearch;
